import React from 'react';
import { formatString } from '../../Common/CommonVariables';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Pronouns = ({ nextStep, prevStep, handleChange, formData, error, step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();


  return (
    <>
      <div>
        <h3 className="page-heading-secondary-black-500 mb-5">{t('pronouns')}</h3>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            id="pronoun1"
            name="pronouns"
            value="She/Her/Hers"
            checked={formatString(formData.pronouns) === 'she/her/hers'}
            onChange={handleChange}
          />
          <label htmlFor="pronoun1" className="multistep-form-radio-checkbox-label">{t('pronounslabel')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            id="pronoun2"
            name="pronouns"
            value="He/Him/His"
            checked={formatString(formData.pronouns) === 'he/him/his'}
            onChange={handleChange}
          />
          <label htmlFor="pronoun2" className="multistep-form-radio-checkbox-label">{t('pronounslabels')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            id="pronoun3"
            name="pronouns"
            value="They/Them/Theirs"
            checked={formatString(formData.pronouns) === 'they/them/theirs'}
            onChange={handleChange}
          />
          <label htmlFor="pronoun3" className="multistep-form-radio-checkbox-label">{t('pronounslabelss')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            id="pronoun4"
            name="pronouns"
            value="Non-binary"
            checked={formatString(formData.pronouns) === 'non-binary'}
            onChange={handleChange}
          />
          <label htmlFor="pronoun4" className="multistep-form-radio-checkbox-label">{t('nonbinary')}</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            id="pronoun5"
            name="pronouns"
            value="Just my name, please"
            checked={formatString(formData.pronouns) === 'justmyname,please'}
            onChange={handleChange}
          />
          <label htmlFor="pronoun5" className="multistep-form-radio-checkbox-label">{t('myname')}</label>
        </div>

        {error && <p className="text-danger">{error}</p>}

        {/* Conditional navigation */}
        {isHighmarkPortal ? (
          <div className="pagination-wrapper mt-5">
            {/* <button className="previous-btn"></button> */}
            <div></div>
            <span className="me-3">{step} of {totalSteps}</span>
            <button className="next-btn" onClick={nextStep}></button>
          </div>
        ) : (
          <div className="mt-5">
            <button className="win-btn-primary mobile-view" onClick={nextStep}>
              {t('next')}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Pronouns;
